import type { EditorPlugin } from '../../../types/aha-editor';
import { concatenateStyle } from '../utils';

const UnderlineMarkPlugin: EditorPlugin = {
  name: 'Underline mark plugin',
  mark: {
    type: 'underline',
    use: ({ props }) =>
      concatenateStyle({ ...props }, 'textDecoration', 'underline'),
  },
};

export default UnderlineMarkPlugin;
